import { Action } from '@ngrx/store';
import { ObstacleModel } from '../../models';

export const GET_OBSTACLES = '[Obstacles] Get';
export const GET_OBSTACLES_SUCCESS = '[Obstacles] Get Success';
export const GET_OBSTACLES_FAILURE = '[Obstacles] Get Failure';
export const GET_RECENT_OBSTACLES = '[Obstacles] Get Recent';
export const GET_RECENT_OBSTACLES_SUCCESS = '[Obstacles] Get Recent Success';
export const GET_RECENT_OBSTACLES_FAILURE = '[Obstacles] Get Recent Failure';
export const NEXT_OBSTACLE = '[Obstacles] Next';


export class GetObstacles implements Action {
    readonly type = GET_OBSTACLES;
}
export class GetRecentObstacles implements Action {
  readonly type = GET_RECENT_OBSTACLES;
}
export class GetRecentObstaclesSuccess implements Action {
  readonly type = GET_RECENT_OBSTACLES_SUCCESS;
  constructor(public recentObstacles: ObstacleModel[]) { }
}
export class GetRecentObstaclesFailure implements Action {
  readonly type = GET_RECENT_OBSTACLES_FAILURE;
  constructor(public error: any) { }
}
export class GetObstaclesSuccess implements Action {
    readonly type = GET_OBSTACLES_SUCCESS;
    constructor(public obstacles: ObstacleModel[]) { }
}
export class GetObstaclesFailure implements Action {
    readonly type = GET_OBSTACLES_FAILURE;
    constructor(public error: any) { }
}
export class NextObstacle implements Action {
    readonly type = NEXT_OBSTACLE;
}

export type All = GetObstacles | GetObstaclesSuccess | GetObstaclesFailure | GetRecentObstacles | GetRecentObstaclesSuccess | GetRecentObstaclesFailure | NextObstacle;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/actions/obstacles.actions.ts